import { queryClient } from '@/lib/api-client.ts'
import { User, useUserStore, OrganizationMembership } from '@/store/user.ts'
import { getCurrentUser, userQueryKey } from '@/lib/actions.ts'

export default async function loaderCommon<T, U>(
  foo: (...args: U[]) => Promise<T>,
  ...args: U[]
): Promise<T | null> {
  try {
    const { setUser, setLoading, setCurrentOrganizationMembership } = useUserStore.getState()
    let user = queryClient.getQueryData<User>(userQueryKey)

    if (!user) {
      if (!navigator.onLine) {
        // Offline with no cached user — can't proceed
        return null
      }
      try {
        user = await queryClient.fetchQuery<User, Error>({
          queryKey: userQueryKey,
          queryFn: getCurrentUser,
        })
      } catch {
        // Fetch failed — fall back to cached data one more time
        // (e.g. network error even though navigator.onLine was true)
        user = queryClient.getQueryData<User>(userQueryKey) ?? undefined
      }
    }

    if (user) {
      setUser(user)
      setLoading(false)
      if (user.organizationMemberships) {
        if (user.activeMembership) {
          const membership: OrganizationMembership | undefined = user.organizationMemberships?.find(membership =>
            //@ts-expect-error @id exists
            membership['@id'] === user.activeMembership
          )
          if (membership) setCurrentOrganizationMembership(membership)
          else setCurrentOrganizationMembership(user?.organizationMemberships?.[0])
        } 
      }
      return await foo(...args)
    } else {
      return null
    }
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Failed to ensure user in loaderCommon:', error)
    }
    return null
  }
}
